"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.axiosResult = axiosResult;

var _clone = require("./clone");

function axiosResult(result, error, httpCode) {
  var code;
  var data;

  if (error) {
    code = httpCode || 400;
    data = error;
  } else {
    code = httpCode || 200;
    data = (0, _clone.clone)(result);
  }

  return [code, data];
}